export default "__VITE_ASSET__DdMsQcDv__"